import styled from 'styled-components';
import theme from '../../constants/theme/theme';

export const Container = styled.div`
	margin-top: 1rem;
	margin-bottom: 6rem;
`;

export const MainHeading = styled.h1`
	color: ${theme.colors.primary};
	font-family: ${theme.fonts.SharpSlab};
	font-weight: ${theme.fonts.weight.bold};
	font-size: 2.5rem;
	margin-bottom: 2rem;
`;

export const AccordionContainer = styled.div``;

export const AccordionHeading = styled.h2`
	font-size: 1.8rem;
	font-weight: ${theme.fonts.weight.bold};
	border-bottom: 1px solid ${theme.colors.grayLight};
	width: 100%;
	padding-bottom: 1rem;
	margin: 1rem 0;
	display: flex;
	justify-content: space-between;
	cursor: pointer;
`;

export const AccordionContent = styled.div<{ collapsed: boolean }>`
	max-height: ${({ collapsed }) => (collapsed ? '0' : '6000px')};
	margin-bottom: ${({ collapsed }) => (collapsed ? '1rem' : '3rem')};
	overflow: hidden;
	opacity: ${({ collapsed }) => (collapsed ? '0' : '1')};
	transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
`;

export const ChevronIcon = styled.span<{ collapsed: boolean }>`
	display: inline-block;
	width: 12px;
	height: 12px;
	border-style: solid;
	border-color: ${theme.colors.primary};
	border-width: 0 2px 2px 0;
	padding: 3px;
	transform: ${({ collapsed }) => (collapsed ? 'rotate(45deg)' : 'rotate(-135deg)')};
	transition: transform 0.5s ease-in-out;
	margin-right: 10px;
	cursor: pointer;
`;

export const AccordionRichTextWrapper = styled.div<{ marginTop?: string; marginBottom?: string }>`
	margin-top: ${({ marginTop }) => marginTop};
	margin-bottom: ${({ marginBottom }) => marginBottom};
	table h1,
	table h2,
	table h3,
	table h4,
	table h5,
	table h6 {
		color: ${theme.colors.primary};
		white-space: nowrap;
		margin: 16px auto;
	}

	tr td {
		padding: 2rem 1rem !important;
	}

	strong {
		color: unset;
	}
`;
